import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import CountriesContent from './CountriesContent'
export default class Countries extends Component {
    render() {
       
        let page = this.props.match.params.page;
        return (
            <div class="wrapper">

                <div class="preloader hide flex-column justify-content-center align-items-center">
                    <img class="animation__shake" src="assets/dist/img/AdminLTELogo.png" alt="AdminLTELogo" height="60" width="60" />
                </div>
                <Navbar />
                <Mainmenu />
                <CountriesContent page={page} />
                <Footer />

            </div>


        )
    }
}
